import { apiClient } from './api';
import { publicBookingApiParamsFromClubRouteKey } from '../utils/club-route-key';

// Helper to build query string with club identifier (supports `s:` / `i:` / `n:` route keys)
const buildClubQuery = (clubRouteKey?: string | null, category?: string): string => {
  const params = publicBookingApiParamsFromClubRouteKey(clubRouteKey);
  if (category) {
    params.append('category', category);
  }
  const queryString = params.toString();
  return queryString ? `?${queryString}` : '';
};

// Products service for booking service - uses PUBLIC endpoints (no auth required)
export const productsService = {
  getProducts: async (clubRouteKey?: string | null) => {
    try {
      // Use public endpoint with club filter - no auth required
      const query = buildClubQuery(clubRouteKey);
      return await apiClient.get(`/products/public/list${query}`);
    } catch (error) {
      console.warn('Failed to fetch products:', error);
      return [];
    }
  },
  
  getProduct: async (id: string, clubRouteKey?: string | null) => {
    try {
      const query = buildClubQuery(clubRouteKey);
      return await apiClient.get(`/products/${id}${query}`);
    } catch (error) {
      console.warn(`Failed to fetch product ${id}:`, error);
      return null;
    }
  },

  // Alias for getProduct to match tax-calculation service expectations
  getById: async (id: string, clubRouteKey?: string | null) => {
    return productsService.getProduct(id, clubRouteKey);
  },

  // Get all products - uses PUBLIC endpoint with club filter
  getAll: async (clubRouteKey?: string | null) => {
    try {
      // Use public endpoint with club filter - no auth required
      const query = buildClubQuery(clubRouteKey);
      const response = await apiClient.get(`/products/public/list${query}`);
      // Return the full response object (matches API response format)
      return response;
    } catch (error) {
      console.warn('Failed to fetch all products:', error);
      return { products: [] };
    }
  },

  // Get extras products - uses PUBLIC endpoint with club filter
  getExtrasProducts: async (clubRouteKey?: string | null) => {
    try {
      // Use public endpoint with category and club filter - no auth required
      const query = buildClubQuery(clubRouteKey, 'extras');
      const response = await apiClient.get<{ products: any[] }>(`/products/public/list${query}`);
      // Extract the products array from the response
      return response.products || [];
    } catch (error) {
      console.warn('Failed to fetch extras products:', error);
      return [];
    }
  }
};
